@if (showVersionUpdateBanner) {
  <div class="version-update-banner">
    <span>גרסה חדשה זמינה</span>
    <button (click)="applyUpdate()">רענן עכשיו</button>
  </div>
}

<div class="container" [class.fullscreen]="isFullscreenRoute()">
  @if (!isFullscreenRoute()) {
    <app-toolbar></app-toolbar>
  }
  <div class="content">
    @if (!isLoginRoute() && !isFullscreenRoute()) {
      <app-menu ></app-menu>
    }
    <div class="router-wrapper">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
@if (loaderService.isLoading()) {
  <making-waves-loader></making-waves-loader>
}